import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import cart from '../images/products-compressed/shopping-cart.jpg';
import appointment from '../images/products-compressed/appointment.jpg';
import businessInteligence from '../images/products-compressed/business-inteligence.jpg';
import education from '../images/products-compressed/education.jpg';
import hrMaanagement from '../images/products-compressed/hr-management.jpg';
import logistics from '../images/products-compressed/logistics.jpg';
import projectmanagement from '../images/products-compressed/project-management.jpg';
import retail from '../images/products-compressed/retail.jpg';
import healthcare from '../images/products-compressed/healthcare.jpg';
import hotel from '../images/products-compressed/hotel.jpg';




const OurProductsSection = () => {
    return (
        <div className="pt-3 position-relative overflow-hidden">
            <Container className="my-5" fluid>
                <div className="text-center mb-5">
                    <div className="position-relative section-title">
                        <h1 className="fs28 title">Our Products</h1>
                        <span className="mirror-text">Our Products</span>
                    </div>
                    <span className="fs16 color-grey3">We innovate things with perfection</span>
                </div>
                <Row>
                    <Col md={{ span: 10, offset: 1 }}>
                        <Row>
                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${cart})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">VeeyaaCart</h2>
                                                <p className="desc mb-0">
                                                    Advanced e-commerce platform with integrated payment solutions and inventory management.
                                                </p>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${education})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">EduManage</h2>
                                                <p className="desc mb-0 text-white">
                                                    Comprehensive school management system with attendance, grades, and parent communication.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${healthcare})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">HealthConnect</h2>
                                                <p className="desc mb-0 text-white">
                                                    Healthcare management solution for clinics and hospitals with patient records and appointments.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${hotel})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">HotelPro</h2>
                                                <p className="desc mb-0 text-white">
                                                    Hotel management system with booking, room service, and guest management features.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${logistics})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">LogiTrack</h2>
                                                <p className="desc mb-0 text-white">
                                                    Logistics and fleet management system with real-time tracking and delivery management.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${retail})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">RetailOS</h2>
                                                <p className="desc mb-0 text-white">
                                                    Point of sale and retail management system with inventory and sales analytics.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${projectmanagement})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">ProjectFlow</h2>
                                                <p className="desc mb-0 text-white">
                                                    Project management tool with task tracking, team collaboration, and reporting.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            {/* <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${appointment})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">AppointEase</h2>
                                                <p className="desc mb-0 text-white">
                                                    Appointment scheduling system for businesses with online booking and reminders.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col> */}

                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${businessInteligence})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">BizAnalytics</h2>
                                                <p className="desc mb-0 text-white">
                                                    Business intelligence tool with data visualization and performance metrics.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col md={6} lg={4}>
                                <Card className="product-cards mb-4">
                                    <Card.Body style={{ backgroundImage: `url(${hrMaanagement})` }}>
                                        <div className='overlay-dark'>
                                            <div className="product-desc-overlay">
                                                <h2 className="fs22 text-white">HRMaster</h2>
                                                <p className="desc mb-0 text-white">
                                                    HR management system with employee records, payroll, and attendance tracking.
                                                </p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {/* <div className="text-center">
                    <button type="button" className="btn btn-quote mt-4">
                        Know More
                    </button>
                </div> */}
            </Container>
        </div>
    );
};

export default OurProductsSection;
